/**
 * Created by Phatbass on 21/02/16.
 */

'use strict';

// TODO: Add all urls
angular.module('far.models.rank', [])
    .service('Rank', function ($log, $http) {
        this.get = function (data, callback) {
            var model = new Rank(data);

            $http.get(Routing.generate('api_discipline_get_discipline_rank', data))
                .then(function (response) {
                    response.data.season = response.data.season.id.toString();

                    response.data.people_xerox = +response.data.people_xerox;
                    response.data.people_xerox = response.data.people_xerox.toString();

                    if (angular.isObject(response.data.class)) {
                        response.data.class = response.data.class.id.toString();
                    }

                    if (angular.isObject(response.data.type)) {
                        response.data.type = response.data.type.id.toString();
                    }

                    model.update(response.data);

                    if (typeof callback == 'function') {
                        callback(model);
                    }
                }, function (response) {
                    $log.error(response);
                });

            return model;
        };

        function Rank(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_discipline_put_discipline_rank', {rank: this.id}) :
                                Routing.generate('api_discipline_post_discipline_rank');

                        var data = angular.merge({}, this);

                        data.people_xerox = Boolean(parseInt(data.people_xerox));

                        data.values = data.values.filter(function (value) {
                            if (value.age && value.city && value.name && value.points) {
                                return true;
                            }
                        });

                        return $http[method](url, data);
                    }
                }
            });
        }
    });